
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/den-sorte-skole",
      function () {
        return require("private-next-pages/archive/den-sorte-skole.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/den-sorte-skole"])
      });
    }
  